import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-amber-500 rounded-lg">
                <i className="ri-play-circle-fill text-white text-xl"></i>
              </div>
              <span className="text-lg font-bold text-white">芒果视频</span>
            </div>
            <p className="text-sm leading-relaxed text-gray-400">
              芒果视频作为西瓜视频、小蓝视频的同类替代选择，为您提供免费高清在线观看服务。资源全、画质好、不缓冲。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">视频分类</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-gray-400 hover:text-amber-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-gray-400 hover:text-amber-400 transition-colors whitespace-nowrap"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-gray-400 hover:text-amber-400 transition-colors whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-gray-400 hover:text-amber-400 transition-colors whitespace-nowrap"
                >
                  用户协议
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-gray-400 hover:text-amber-400 transition-colors whitespace-nowrap"
                >
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
            <ul className="flex flex-col gap-2.5">
              <li className="text-sm text-gray-400">
                <i className="ri-mail-line mr-2"></i>
                contact@mangguoshipin.com
              </li>
              <li className="text-sm text-gray-400">
                <i className="ri-phone-line mr-2"></i>
                400-888-6666
              </li>
              <li className="text-sm text-gray-400">
                <i className="ri-map-pin-line mr-2"></i>
                长沙市岳麓区芒果视频大厦
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500">
            &copy; 2026 芒果视频 MangGuoShiPin.com 版权所有 | 湘ICP备2026000001号
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:bg-amber-500 hover:text-white transition-colors"
              aria-label="微信"
              rel="nofollow"
            >
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:bg-amber-500 hover:text-white transition-colors"
              aria-label="微博"
              rel="nofollow"
            >
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:bg-amber-500 hover:text-white transition-colors"
              aria-label="QQ"
              rel="nofollow"
            >
              <i className="ri-qq-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}